import api from './api'

export const faceService = {
  // Register a new face
  async registerFace(imageFile, personName, relationship = 'other', email = '', phone = '', notes = '') {
    const formData = new FormData()
    formData.append('image', imageFile)
    formData.append('personName', personName)
    formData.append('relationship', relationship)
    if (email) formData.append('email', email)
    if (phone) formData.append('phone', phone)
    if (notes) formData.append('notes', notes)

    const response = await api.post('/faces/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response // api.js already returns response.data
  },

  // Get all registered faces
  async getRegisteredFaces(page = 1, limit = 20, relationship = '', search = '') {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    })
    
    if (relationship) params.append('relationship', relationship)
    if (search) params.append('search', search)

    const response = await api.get(`/faces?${params}`)
    return response // api.js already returns response.data
  },

  // Recognize faces in an image
  async recognizeFaces(imageFile, location = '', context = '', threshold = 0.6) {
    const formData = new FormData()
    formData.append('image', imageFile)
    formData.append('location', location)
    formData.append('context', context)
    formData.append('threshold', threshold.toString())

    const response = await api.post('/faces/recognize', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response // api.js already returns response.data
  },

  // Get face recognition stats
  async getFaceStats() {
    const response = await api.get('/faces/stats')
    return response.data
  },

  // Get specific face record
  async getFaceRecord(faceId) {
    const response = await api.get(`/faces/${faceId}`)
    return response.data
  },

  // Update face information
  async updateFace(faceId, updateData) {
    const response = await api.put(`/faces/${faceId}`, updateData)
    return response.data
  },

  // Delete face record
  async deleteFace(faceId) {
    const response = await api.delete(`/faces/${faceId}`)
    return response.data
  }
}
